import { LowerCasePipe, TitleCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SmsDto } from '@workspace/data-types';
import {
  AvatarAuraComponent,
  BaseDataTableCoreComponent,
  DataTableComponent,
  LuxonDatePipe,
  SendStatusChipComponent,
  SimpleChipComponent,
} from '@workspace/ng-aura';
import { SmsActionDisplayPipe, SmsTagDisplayPipe } from '@workspace/ng-data-access';
import { SmsColumnKey } from './abstract-sms-data-table.component';
import { SmsDataTableFilterCoreComponent } from './filter/sms-data-table-filter.component';

@Component({
  selector: 'core-sms-data-table',
  standalone: true,
  templateUrl: './sms-data-table.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    TitleCasePipe,
    LowerCasePipe,
    SmsActionDisplayPipe,
    SmsTagDisplayPipe,
    MatIconModule,
    MatTooltipModule,
    SmsDataTableFilterCoreComponent,
    AvatarAuraComponent,
    RouterModule,
    MatButton,
    SimpleChipComponent,
    SendStatusChipComponent,
  ],
})
export class SmsDataTableCoreComponent extends BaseDataTableCoreComponent<SmsDto, SmsColumnKey> {}
